<template>
  <div :class="anchorLinkClasses">
    <a
      :class="linkTitleClasses"
      :href="href"
      :data-scroll-offset="scrollOffset"
      :data-href="href"
      @click.prevent="goAnchor"
      :title="title"
    >
      {{ title }}
    </a>
    <slot />
  </div>
</template>
<script>
import { CONFIG_PROVIDER, getPrefixCls } from '@ss/mtd-vue/lib/utils/config';

export default {
  name: 'MtdAnchorLink',
  inject: {
    anchorCom: { from: 'anchorCom' },
    config: {
      from: CONFIG_PROVIDER,
      default: {
        getPrefixCls
      }
    }
  },
  props: {
    href: String,
    title: String,
    scrollOffset: {
      type: Number,
      default() {
        return this.anchorCom.scrollOffset;
      }
    }
  },
  computed: {
    prefix() {
      return this.config.getPrefixCls('anchor-link');
    },
    anchorLinkClasses() {
      return [
        this.prefix,
        this.anchorCom.currentLink === this.href ? `${this.prefix}-active` : ''
      ];
    },
    linkTitleClasses() {
      return [`${this.prefix}-title`];
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.anchorCom.init();
    });
  },
  methods: {
    goAnchor() {
      this.anchorCom.currentLink = this.href;
      window.location.href = this.href;
      this.anchorCom.handleHashChange();
      this.anchorCom.handleScrollTo();
      const lastScrollTop = this.anchorCom.scrollElement.scrollTop;
      this.anchorCom.$emit('select', this.href);
      // 在上面路由改变之后，会触发页面刷新，滚动条会回到0的位置，所以要将滚动条回归到上次的位置
      this.anchorCom.scrollElement.scrollTop = lastScrollTop;
    }
  }
};
</script>
